export default {
    '.css': 'scss',
    '.js': 'js',
    '.scss': 'scss'
};
